<template>
    <header :class="[
        'fixed left-1/2 transform -translate-x-1/2 z-50 w-[95vw] sm:w-[90vw] md:w-[85vw] lg:w-[80vw] bg-white/90 backdrop-blur-md text-dark px-4 sm:px-6 md:px-8 lg:px-12 py-3 md:py-4 shadow-md rounded-xl transition-transform duration-700',
        isHidden ? '-translate-y-[200%]' : 'translate-y-0',
        'top-4'
    ]">
        <div class="relative flex items-center justify-between w-full">

            <!-- Liens gauche (XL ≥1280px) -->
            <nav class="hidden xl:flex items-center space-x-8 text-base font-medium uppercase">
                <RouterLink to="/" class="hover:text-primary transition">Accueil</RouterLink>
                <RouterLink to="/pricing" class="hover:text-primary transition">Tarifs</RouterLink>
                <RouterLink to="/contact" class="hover:text-primary transition">Contact</RouterLink>
            </nav>

            <!-- Logo -->
            <RouterLink to="/" class="flex-shrink-0 lg:ml-0 xl:absolute xl:left-1/2 xl:transform xl:-translate-x-1/2">
                <img src="@/assets/logo.png" alt="My Profolia" class="h-10 md:h-12 lg:h-14 object-contain" />
            </RouterLink>

            <!-- CTA XL (≥1280px) -->
            <div class="hidden xl:flex items-center space-x-4">
                <RouterLink to="/login"
                    class="inline-flex items-center gap-3 text-gray-700 font-semibold px-6 py-3 text-base rounded hover:bg-gray-100 transition">
                    <i class="fas fa-user text-base"></i>
                    <span>Connexion</span>
                </RouterLink>
                <RouterLink to="/register"
                    class="inline-flex items-center gap-3 bg-gray-700 text-white font-semibold px-6 py-3 text-base rounded hover:bg-gray-300 hover:text-dark transition">
                    <i class="fas fa-rocket text-base"></i>
                    <span>Créer ma vitrine</span>
                </RouterLink>
            </div>

            <!-- CTA + Burger LG (1024 ≤ largeur <1280) -->
            <div class="hidden lg:flex xl:hidden items-center space-x-2">
                <!-- CTA -->
                <RouterLink to="/login"
                    class="inline-flex items-center gap-2 text-gray-700 font-semibold px-4 py-2 text-base rounded hover:bg-gray-100 transition">
                    <i class="fas fa-user text-base"></i>
                    <span>Connexion</span>
                </RouterLink>
                <RouterLink to="/register"
                    class="inline-flex items-center gap-2 bg-gray-700 text-white font-semibold px-4 py-2 text-base rounded hover:bg-gray-300 hover:text-dark transition">
                    <i class="fas fa-rocket text-base"></i>
                    <span>Créer ma vitrine</span>
                </RouterLink>
                <!-- Burger -->
                <button @click="isOpen = !isOpen" class="pl-4 focus:outline-none">
                    <svg v-if="!isOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 stroke-gray-700" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 stroke-gray-700" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <!-- Burger menu <LG -->
            <div class="flex lg:hidden ml-auto">
                <button @click="isOpen = !isOpen" class="focus:outline-none">
                    <svg v-if="!isOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 stroke-violet-500" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 stroke-violet-500" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- MENU BURGER -->
        <div v-if="isOpen" class="mt-4 flex flex-col space-y-4 text-base font-medium">

            <!-- LG (1024 ≤ largeur <1280) : uniquement liens -->
            <div class="hidden lg:flex xl:hidden flex-col space-y-4">
                <RouterLink to="/" @click="isOpen = false" class="hover:text-primary">Accueil</RouterLink>
                <RouterLink to="/pricing" @click="isOpen = false" class="hover:text-primary">Tarifs</RouterLink>
                <RouterLink to="/contact" @click="isOpen = false" class="hover:text-primary">Contact</RouterLink>
            </div>

            <!-- <LG (<1024) : liens + CTA -->
            <div class="flex flex-col lg:hidden space-y-4">
                <RouterLink to="/" @click="isOpen = false" class="hover:text-primary">Accueil</RouterLink>
                <RouterLink to="/pricing" @click="isOpen = false" class="hover:text-primary">Tarifs</RouterLink>
                <RouterLink to="/contact" @click="isOpen = false" class="hover:text-primary">Contact</RouterLink>
                <RouterLink to="/login" @click="isOpen = false"
                    class="inline-flex items-center bg-gray-300 text-dark font-semibold px-4 py-2 rounded hover:bg-gray-700 hover:text-white transition">
                    <i class="fas fa-user text-base mr-2"></i>
                    Connexion
                </RouterLink>
                <RouterLink to="/register" @click="isOpen = false"
                    class="inline-flex items-center bg-gray-700 text-white font-semibold px-4 py-2 rounded hover:bg-gray-300 hover:text-dark transition">
                    <i class="fas fa-rocket mr-2"></i>
                    Créer ma vitrine
                </RouterLink>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
const isOpen = ref(false)
const isHidden = ref(false);
let lastScroll = 0;

const handleScroll = () => {
    const currentScroll = window.scrollY;
    if (currentScroll > lastScroll && currentScroll > 100) {
        // Scroll vers le bas → cacher
        isHidden.value = true;
    } else {
        // Scroll vers le haut → montrer
        isHidden.value = false;
    }
    lastScroll = currentScroll;
};

onMounted(() => {
    window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
});
</script>
